export default "__VITE_ASSET__CQgztQvu__"